import React, { useState } from 'react';
import RoleList from './roles/RoleList';
import PermissionList from './roles/PermissionList';
import RoleDetails from './roles/RoleDetails';
import RoleForm from './roles/RoleForm';
import PermissionForm from './roles/PermissionForm';
import UserRoleAssignment from './roles/UserRoleAssignment';
import './RolesAndPermissions.css';
import UserList from "./roles/UserList";

const RolesAndPermissions = () => {
  const [selectedRole, setSelectedRole] = useState(null);
  const [showRoleForm, setShowRoleForm] = useState(false);
  const [showPermissionForm, setShowPermissionForm] = useState(false);
    const [refreshRoles, setRefreshRoles] = useState(false);
    const [refreshPermissions, setRefreshPermissions] = useState(false);


  const handleRoleSelect = (role) => {
    setSelectedRole(role);
  };

  const handleOpenRoleForm = () => {
    setShowRoleForm(true);
  };

  const handleCloseRoleForm = () => {
    setShowRoleForm(false);
      setRefreshRoles(prev => !prev)
  };

  const handleOpenPermissionForm = () => {
    setShowPermissionForm(true);
  };

  const handleClosePermissionForm = () => {
    setShowPermissionForm(false);
      setRefreshPermissions(prev => !prev)
  };

   const handleRoleDeleted = () => {
      setRefreshRoles(prev => !prev)
    };

    const handlePermissionDeleted = () =>{
        setRefreshPermissions(prev => !prev);
    }

  return (
    
          <div className="RolesAndPermissions">
                 <div className="main-block">
            <h2>Пользователи</h2>
            <UserList />
         </div>
         
        <div className="main-block">
            <UserRoleAssignment />
        </div>

        <div className="main-block">
            <div className="section-header">
                <h2>Роли</h2>
                <button onClick={handleOpenRoleForm} className="create-button">
                Создать роль
              </button>
            </div>
            <RoleList onSelectRole={handleRoleSelect} refresh={refreshRoles} onRoleDeleted={handleRoleDeleted} />
        </div>
        <div className="main-block">
            <RoleDetails selectedRole={selectedRole} />
        </div>

        <div className="main-block">
            <div className="section-header">
                <h2>Права</h2>
              <button onClick={handleOpenPermissionForm} className="create-button">
                Создать право
              </button>
            </div>
            <PermissionList refresh={refreshPermissions} onPermissionDeleted={handlePermissionDeleted}/>
         </div>



      {showRoleForm && <RoleForm onClose={handleCloseRoleForm} />}
      {showPermissionForm && <PermissionForm onClose={handleClosePermissionForm} />}
    </div>
  );
};

export default RolesAndPermissions;
